import { RentalStatsByType } from 'types/CarTracking';

export const mockRentalStatsByTypeFull: RentalStatsByType = {
    rental_counts: {
        hourly: { count: 42, percentage: 42 },
        'flat rate': { count: 19, percentage: 19 },
        daily: { count: 13, percentage: 13 },
        monthly: { count: 11, percentage: 11 },
        bulk_rental: { count: 9, percentage: 9 },
        enterprise: { count: 6, percentage: 6 },
    },
};

export const mockRentalStatsByTypeEmpty: RentalStatsByType = {
    rental_counts: {},
};
